import type { CreateUserRequest } from "../api/types";

/**
 * 解析批量建号 CSV 文本(§3.2),列顺序:
 *   account_id,username,given_name,family_name,email,tier[,auto_activate]
 * 第 7 列(auto_activate)可选,取值 "是"/"否"/"true"/"false"(大小写不敏感)、
 * 或直接留空——留空/缺省时使用 defaultAutoActivate(页面上"是否自动激活"下拉框
 * 的当前值),不强制要求所有已有 CSV 都补一列才能继续用。
 * 忽略空行和 # 开头的注释行,拆成单独模块便于单测(不依赖 React 组件渲染)。
 */
export function parseCsvUsers(csvText: string, defaultAutoActivate: boolean = true): CreateUserRequest[] {
  return csvText
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line && !line.startsWith("#"))
    .map((line) => {
      const [account_id, username, given_name, family_name, email, tier, autoActivateRaw] = line
        .split(",")
        .map((v) => v.trim());
      const normalized = (autoActivateRaw || "").toLowerCase();
      const auto_activate =
        normalized === ""
          ? defaultAutoActivate
          : !["否", "false", "no", "0"].includes(normalized);
      return { account_id, username, given_name, family_name, email, tier, auto_activate };
    });
}
